import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AIFeatures from './components/AIFeatures';
import ClimateData from './components/ClimateData';
import DamageMapSection from './components/DamageMapSection';
import RecoveryMap from './components/RecoveryMap';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatIfMap from './components/WhatIfMap';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <AIFeatures />
      <DamageMapSection />
      <RecoveryMap />
      <WhatIfMap />
      <ClimateData />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
